import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';
import { COMMON_USERS_FOR_VOCITEMS_CREATED_BY, COMMON_USERS_FOR_VOCITEMS_ONBEHALF_OF, COMMON_VOC_EVAL_ACCOUNT_NAME } from '@/voc/helpers/aggs.helper';
import { operators as o } from '@pendo/aggregations';

const { VOC } = PRODUCT_AREAS || {};
const { GENERAL } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'VocItemsSearchAggregation',
    productArea: VOC,
    subProductArea: GENERAL,
    responseFormat: 'rows',
    build: ({ type, searchText = '', accountDisplayName = null, accountDomain = null, includeInsights = false, itemsLimit = 10, limit = 0 }) => {
        const feedbackPipeline = [
            o.fork(
                ...COMMON_USERS_FOR_VOCITEMS_ONBEHALF_OF,
                o.pipeline(o.bulkExpand('accountObj', 'account', 'accountId')),
            ),
            o.join('id'),
            o.evaluate({
                'account.id': 'accountId',
                'sourceName': 'if (len(split(source, "")) == 36 && len(split(source, "-")) == 5, sourceCategory, source)',
                ...(accountDomain ? { 'account.domain': `accountObj.${accountDomain}` } : {}),
            }),
            ...COMMON_VOC_EVAL_ACCOUNT_NAME(accountDisplayName, 'account.name', 'accountObj', 'account.id'),
        ];

        const pipeline = [
            o.spawn(
                o.pipeline(
                    o.sources.vocItems({
                        appId: 'expandAppIds("*")',
                        ...(type && { type }), // defaults to idea if not specified
                    }),
                    o.merge(
                        ['id'],
                        o.mappings({
                            id: 'id',
                            esFound: 'esFound',
                            score: 'score',
                        }),
                        o.pipeline(
                            o.sources.elasticsearch({
                                index: 'vocitems',
                                input: searchText,
                                type: type || 'idea',
                                config: {
                                    includeScore: true,
                                    querySettings: { exactMatch: true },
                                },
                            }),
                            ...(itemsLimit ? [o.sort('-score'), o.limit(itemsLimit)] : []),
                        ),
                    ),
                    o.filter('esFound == true'),
                    ...(type === 'feedback' ? feedbackPipeline : [
                        o.fork(
                            ...COMMON_USERS_FOR_VOCITEMS_CREATED_BY,
                        ),
                    ]),
                    o.evaluate({
                        title: 'formDataContent[0]',
                        description: 'join(formDataContent[1:len(formDataContent)], " ")',
                        productAreaIds: 'productAreaVocIds',
                    }),
                ),
                ...(!type ? [
                    o.pipeline(
                        o.sources.vocItems({
                            appId: 'expandAppIds("*")',
                            type: 'feedback',
                        }),
                        o.merge(
                            ['id'],
                            o.mappings({
                                id: 'id',
                                esFound: 'esFound',
                                score: 'score',
                            }),
                            o.pipeline(
                                o.sources.elasticsearch({
                                    index: 'vocitems',
                                    input: searchText,
                                    type: 'feedback',
                                    config: {
                                        includeScore: true,
                                        querySettings: { exactMatch: true },
                                    },
                                }),
                                ...(itemsLimit ? [o.sort('-score'), o.limit(itemsLimit)] : []),
                            ),
                        ),
                        o.filter('esFound == true'),
                        ...feedbackPipeline,
                        o.evaluate({
                            title: 'formDataContent[0]',
                            description: 'join(formDataContent[1:len(formDataContent)], " ")',
                            productAreaIds: 'productAreaVocIds',
                        }),
                    ),
                ]: []),
                ...(includeInsights ? [
                    o.pipeline(
                        o.sources.vocInsights({
                            appId: 'expandAppIds("*")',
                        }),
                        o.merge(
                            ['id'],
                            o.mappings({
                                id: 'id',
                                esFound: 'esFound',
                                score: 'score',
                            }),
                            o.pipeline(
                                o.sources.elasticsearch({
                                    index: 'vocinsights',
                                    input: searchText,
                                    config: {
                                        includeScore: true,
                                        includeHighlights: true,
                                        querySettings: { exactMatch: true },
                                    },
                                }),
                            ),
                        ),
                        o.filter('esFound == true'),
                        ...(itemsLimit ? [o.sort('-score'), o.limit(itemsLimit)] : []),
                        o.merge(
                            ['vocItemKey'],
                            {},
                            o.pipeline(
                                o.sources.vocItems({
                                    appId: 'expandAppIds("*")',
                                    type: 'feedback',
                                }),
                                ...feedbackPipeline,
                                o.select(['account', 'onBehalfOf', 'appIds', 'createdAt', 'sourceName', { vocItemKey: 'id' }, { vocItemId: 'id' }]),
                            ),
                        ),
                        o.filter('!isNull(vocItemId)'),
                        o.select({
                            id: 'id',
                            title: 'summary',
                            description: 'explanation',
                            productAreaIds: 'productAreaId',
                            keyQuote: 'keyQuote',
                            feedbackType: 'feedbackType',
                            type: '"highlight"',
                            appIds: 'appIds',
                            account: 'account',
                            onBehalfOf: 'onBehalfOf',
                            createdAt: 'createdAt',
                            sourceName: 'sourceName',
                            vocItemId: 'vocItemId',
                        }),
                    ),
                ] :[]),
            ),
            o.sort('-score'),
            ...(limit ? [o.limit(limit)] : []),
            o.select([
                'id',
                'type',
                'title',
                'description',
                'createdAt',
                'createdBy',
                'onBehalfOf',
                'account',
                'appIds',
                'productAreaIds',
                'sourceName',
                'keyQuote',
                'feedbackType',
                'vocItemId',
            ]),
        ];

        return o.pipeline(...pipeline);
    },
};
